module.exports = __webpack_public_path__ + "img/elephant_stand.c5cf1ee6.png";